// Атрибут-маркер: клик по элементу с ним не закрывает превью объявления на карте.
// Контракт между UI-элементами (напр. кнопкой раскрытия листинга) и автозакрытием балуна.
export const KEEP_OFFER_PREVIEW_OPEN_ATTR = 'data-keep-offer-preview-open';
